import { render, staticRenderFns } from "./ListInspection.vue?vue&type=template&id=2118417a"
import script from "./ListInspection.vue?vue&type=script&lang=js"
export * from "./ListInspection.vue?vue&type=script&lang=js"
import style0 from "./ListInspection.vue?vue&type=style&index=0&id=2118417a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports